// imgUrl change to base64
export default function base64(url: string) {
  return new Promise((resolve) => {
    const image = new Image();
    // first
    image.crossOrigin = 'Anonymous';
    // second
    image.src = url;
    image.onload = function () {
      const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
      canvas.width = image.width;
      canvas.height = image.height;
      canvas.getContext('2d')?.drawImage(image, 0, 0);
      // toDataUrl(a, b)
      // a: img type
      // b: img quality: 0-1,(default: 0.92)
      const dataURL = canvas.toDataURL('image/jpeg');
      resolve(dataURL);
    };
    image.onerror = () => {
      resolve({ message: 'error: imgUrl change to base64' });
    };
  });
}
